import styled from "styled-components";

export const FilterSectionStyles = styled.div`
    background: ${({ theme }) => theme.playerContentBackground};
    width: 220px;
    // width: calc((100% / 11) * 2);
    position: sticky;
    padding-right: 10px;
    top: 225px;
    left: 0px;
    right: 0px;
    height: auto;
    // background: #f9faf7;
    // z-index: 9999999;
    z-index:9999;
    height: calc(100vh - 281px);
    overflow: auto;
    
    @media(max-width: 1366px){
      width : 260px;
      height: calc(100vh - 209px)
    }
    @media(max-width: 1365px){
      width : 260px;
      height: calc(100vh - 295px)
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: transparent;
        // background-color: #1b1b1b;
        background-color: ${({ theme }) => theme.scrollbarTrack};
        position: fixed;
        top: 0px;
        right: 10px;
        bottom: 0px;
      }
    
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #F5F5F5;
        position: fixed;
        top: 0px;
        right: 10px;
        bottom: 0px;
      }
    
      &::-webkit-scrollbar-thumb {
        // background-color: rgba(255, 255, 255, 0.05);
        background-color: ${({ theme }) => theme.scrollbarThumb};
        border-radius: 10px;
        position: fixed;
        top: 0px;
        right: 10px;
        bottom: 0px;
      }
`;

export const SortDropdown = styled.div`
  background-color: ${({ theme }) => theme.secondaryButtonBackground};
  box-shadow: ${({ theme }) => theme.boxShadow};
`;